export default __webpack_public_path__ + "static/media/GR6 4B-2D-4EC.e49abea4.jpg";